import "./assets/css/index.css";
import React from "react";
import Header from "./components/core/Header";
import AppList from "./components/AppList";
import Main from "./components/products/Main";
import { Routes, Route } from "react-router-dom";
import CareerPage from "./pages/career";

function App() {
  return (
    <div className="App" id="app" style={{ fontFamily: "Roboto" }}>
      <Header />
      <Routes>
        <Route path="/edc15" element={<Main productName="edc15" />} />
        <Route path="/med9" element={<Main productName="med9" />} />
        <Route path='/careers' element={<CareerPage/> } />
        <Route path="/" element={<AppList />} />
      </Routes>
    </div>
  );
}

export default App;
